import { Preferences } from "../../profile/objects/preferences";
import { COMMERCIAL_INFORMATION_MODULE, DEFAULT_COLUMN } from "../constant/commercialInformationConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setCommercialInformationPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: COMMERCIAL_INFORMATION_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });